import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { Obj, type ObjId } from './Obj.tsx'

/** Friendly empty/error state: a 3D object (`obj`) or a line icon, one sentence, one action. */
export function EmptyState({ Icon, obj, title, children, action }: { Icon?: LucideIcon; obj?: ObjId; title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className="empty">
      {obj ? <Obj id={obj} size={112} className="empty-obj" /> : Icon && <div className="ic" aria-hidden="true"><Icon size={28} /></div>}
      <h2>{title}</h2>
      {children && <p>{children}</p>}
      {action}
    </div>
  )
}
